module.exports = "<p>Pipilotti Rist in conversation<br>with MCA Young Guides</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room10/audio1/content.md
// module id = 830
// module chunks = 0